import { state } from "./state";

export default {
  getLoading() {
    return state.loading;
  },
  getSmsList() {
    return state.smses;
  },

  getTotalPages() {
    return state.totalPage;
  },

  getTotal() {
    return state.totalItems;
  },

  getSmsRecipientReport() {
    return state.smsRecipientReport;
  },

  getRecipientReportTotalPages() {
    return state.recipientReportTotalPage;
  },

  getRecipientReportTotal() {
    return state.recipientReportTotalItems;
  },

  getLastSms() {
    return state.lastSms;
  },

  getActiveRecipient() {
    return state.activeRecipient;
  },

  getCurrentMessageList() {
    return state.currentMessageList;
  },

  getUnreadCount() {
    return state.unreadCount;
  },

  getSmsReport() {
    return state.smsReport;
  },

  getSmsReportTotalPages() {
    return state.smsReportTotalPage;
  },

  getSmsReportTotal() {
    return state.smsReportTotalItems;
  },

  getSmsResellerReport() {
    return state.smsResellerReport;
  },

  getSmsResellerReportTotalPages() {
    return state.smsResellerTotalPage;
  },

  getSmsResellerReportTotal() {
    return state.smsResellerTotalItems;
  },
};
